import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import './dismissible-message.scss';

export function DismissibleMessage({ children = null, onClose = noop, containerClassName = '' }) {
  return (
    <div role="alert" className={classnames('d-flex gap-0_5 rounded-8 pos-r', containerClassName)}>
      {children}
      <button
        onClick={onClose}
        className="dismissible-message-close-button btn p-0 pos-a text-cool-gray-30"
        data-testid="close-button"
        aria-label="Close message"
      >
        <span className="icon-cross2" aria-hidden />
      </button>
    </div>
  );
}

DismissibleMessage.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  containerClassName: PropTypes.string,
};
